/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_By_TimeInputs */

const en_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By Time`)
};

const fr_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par temps`)
};

const de_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Zeit`)
};

const it_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per tempo`)
};

const ru_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По времени`)
};

const es_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por tiempo`)
};

const zh_cn2_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间`)
};

const ja_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間別`)
};

const hi_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय तक`)
};

const pt_pt2_segment_event_group_by_time = /** @type {(inputs: Segment_Event_Group_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por tempo`)
};

/**
* | output |
* | --- |
* | "By Time" |
*
* @param {Segment_Event_Group_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_by_time = /** @type {((inputs?: Segment_Event_Group_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_by_time(inputs)
	if (locale === "de") return de_segment_event_group_by_time(inputs)
	if (locale === "it") return it_segment_event_group_by_time(inputs)
	if (locale === "ru") return ru_segment_event_group_by_time(inputs)
	if (locale === "es") return es_segment_event_group_by_time(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_by_time(inputs)
	if (locale === "ja") return ja_segment_event_group_by_time(inputs)
	if (locale === "hi") return hi_segment_event_group_by_time(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_by_time(inputs)
	return en_segment_event_group_by_time(inputs)
});